import { useEffect, useState } from "react";
import { get_lessons } from "../../../server/requests";
import RowList from "../../Row_List/RowList";
import Loading from "../../Loading/Loading";

export default function Lessons({isGuest}) {
    const [listLessons, setListLessons] = useState([])
    const [loadingShow, setLoadingShow] = useState(false)
    useEffect(() => {
        setLoadingShow(true)
        get_lessons({}, data => {
            console.log(data)
            setListLessons([...data])
            setLoadingShow(false)
        }, err => console.log(err, 'error'))
    }, [])
    return (
        <div className="container">
            <div className="list_movies">
                {loadingShow ?
                    <Loading />
                    : listLessons.map((row, index) => {
                        return row.movies && row.movies.length ?
                            <RowList
                                key={row.id}
                                title={row.name}
                                type={'movies'}
                                row={row}
                                array={row.movies}
                                rowIndex={index}
                                content_type={'lessons'}
                                isGuest={isGuest}
                            /> : null

                    })}
            </div>
        </div>
    )
}